import { UserManager } from 'paycor-oidc-client';
import config from 'config';

export default () => {
	let manager = new UserManager(config.securitySettings);
	return manager.getAuthorizationHeader();
};
